import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Navbar from "../Navbar/Main";
import Footer from "../Footer/Main";
import { Pagination } from "../DataTable";
import SFsidebar from "./sfsidebar";
import DOMPurify from "dompurify";

export const Ecreview = () => {
  const [clicked, setClicked] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState("Economic_review");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const ITEMS_PER_PAGE = 10;

  useEffect(() => {
    axios
      .get(`/Economic_Review`)
      .then((res) => {
        setDocuments(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError("Failed to load documents.");
        setLoading(false);
      });
  }, []);

const categories = [
  { key: "economic_review", label: "Economic Review - Recent", icon: "📖" },
  { key: "economic_review_archive", label: "Economic Review - Archives", icon: "📘" },
];

  // Count per category
  const counts = useMemo(() => {
  return documents.reduce(
    (acc, d) => {
      const category = (d.category || "Economic_review").toLowerCase();
      acc[category] = (acc[category] || 0) + 1;
      return acc;
    },
    { economic_review: 0, economic_review_archive: 0 }
  );
}, [documents]);

const filteredDocs = useMemo(
  () =>
    documents.filter(
      (d) =>
        (d.category || "Economic_review").toLowerCase() ===
        selectedCategory.toLowerCase()
    ),
  [documents, selectedCategory]
);

  const paginatedDocs = useMemo(() => {
    const start = (currentPage - 1) * ITEMS_PER_PAGE;
    return filteredDocs.slice(start, start + ITEMS_PER_PAGE);
  }, [filteredDocs, currentPage]);

  const normalizeLink = (url) => {
    if (!url) return "#";
    return url.startsWith("http") ? url : `https://${url}`;
  };

  if (loading) {
    return (
      <div className="text-center my-4">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading…</span>
        </div>
      </div>
    );
  }

  if (error) {
    return <div className="alert alert-danger text-center my-4">{error}</div>;
  }

  return (
    <>
      <Navbar />
      <section className="page-header">
        <div className="page-header__bg"></div>
        <div className="container">
          <ul className="thm-breadcrumb list-unstyled">
            <li>
              <Link to="/">Home</Link>
            </li>
          </ul>
        </div>
      </section>

      <section className="service-details pt-120 pb-120">
        <div className="container">
          <div className="row row-gutter-y-50 contact-info-one">
            <div className="col-lg-8">
              <div className="service-details__content">
                <div className="row row-gutter-y-30">
                  <div className="col-md-12">
                    <h3 className="service-details__title">
                      Get to know about BNR Economic Review
                    </h3>
                    <p>
                      BNR Economic Review is devoted to publishing articles of
                      interest to policymakers, academics and practitioners on a
                      wide range of economic issues with policy relevance. The
                      journal welcomes empirical and theoretical studies with an
                      emphasis on central bank responsibilities and other
                      economic policies. The journal aims to promote interaction
                      between researchers and policymakers and contribute to
                      knowledge dissemination.
                    </p>

                    <p>
                      The views expressed in each article are those of the
                      authors and do not necessarily represent the views of the
                      National Bank of Rwanda.
                    </p>

                    <p>
                      For information about the BNR Economic Review contact{" "}
                      <a href="mailto:economicreview@bnr.rw">
                        economicreview@bnr.rw
                      </a>
                    </p>

              <div className="faq-tabs mb-4 text-center">
                {categories.map(({ key, label, icon }) => (
                  <button
                    key={key}
                    onClick={() => {
                      setSelectedCategory(key);
                      setCurrentPage(1); // Reset pagination when switching tab
                      setClicked(null);  // Close any open accordion
                    }}
                    className={`faq-tab-button position-relative ${selectedCategory === key ? 'active' : ''}`}
                        >
                    <span className="me-2">{icon}</span>
                    {label}
                    <span className="faq-count-circle">{counts[key] || 0}</span>
                  </button>
                ))}
              </div>

             {/* Doc Accordions for Selected Category */}
                    {paginatedDocs.length === 0 ? (
                        <p className="text-center">No documents found.</p>
                    ) : (
                        paginatedDocs.map((d, index) => (
                            <div
                                key={d.name || index}
                                className={`accrodion-grp service-details__accrodion mb-3 ${clicked === d.name ? "active" : ""}`}
                                data-grp-name="service-details__accrodion-1"
                            >
                                <div className="accrodion wow fadeInUp" data-wow-delay="0ms">
                                    <div
                                        className="accrodion-title"
                                        onClick={() => setClicked(clicked === d.name ? null : d.name)}
                                    >  <h4>BNR Economic Review {d.latest_issue}</h4>
                                        <span className="accrodion-icon"></span>
                                    </div>
                                    {clicked === d.name && (
                                        <div className="accrodion-content">
                                          <div className="inner_doc" >
                                          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(`${d.summary}`)}} />
                                              {/*{d.summary} */}
                                              <div/>
                                          <p></p> 
                                          {/*<Link to={d.file} target="_blank" rel="noopener noreferrer">Download/View</Link>*/}
                                          <Link to={`https://${d.link}`} target="_blank" rel="noopener noreferrer">More Details</Link>
                                          </div>
                                      </div>
                                    )}
                                </div>
                            </div>
                        ))
                    )}
              {/* Pagination */}
                    <div className="d-flex justify-content-center mt-4">
                      <Pagination
                        total={filteredDocs.length}
                        itemsPerPage={ITEMS_PER_PAGE}
                        currentPage={currentPage}
                        onPageChange={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <SFsidebar />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};
